import { useState, useEffect } from "react";
import { ErrorCard, LoadingCard, MainContainer } from "../../components";
import { Button, Input, Card, CardBody } from "@heroui/react";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetail } from "../../state/shapeSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";


const CreateShapeMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { detailParams, isNewEntry } = useSelector((state) => state.shape);
    const [submitBtnId, setSubmitBtnId] = useState("")
    const [formData, setFormData] = useState({
        S_Code: "",
        S_Name: "",
        S_Group: "",
        S_Ord: "",
    });

    const { data: shapeDetails = [], isPending: isLoading, mutate: filterDetail } = usePost({
        url: apiRoute.shape.getshapeforupdate,
        queryKey: "fetchShapeById",
    });


    // Fetch data when `detailParams?.S_Code` exists
    useEffect(() => {
        if (detailParams && Object.keys(detailParams).length > 0) {
            console.log(detailParams)
            filterDetail({
                data: {
                    S_Code: detailParams.S_Code
                }
            })
        }
    }, [detailParams]);

    useEffect(() => {
        if (!isNewEntry && shapeDetails && Object.keys(shapeDetails).length > 0) {
            setFormData({
                S_Code: shapeDetails.S_Code || "",
                S_Name: shapeDetails.S_Name || "",
                S_Group: shapeDetails.S_Group || "",
                S_Ord: shapeDetails.S_Ord || "",
            });
            console.log(shapeDetails.S_Code, isNewEntry, formData)

        }
    }, [shapeDetails]);



    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const { mutate: addUpdateShape, isPending, isError } = usePost({
        queryKey: "shapes",
        url: apiRoute.shape.addupdateShape,
        successMessage: "Shape saved successfully!",
        onSuccessTasks: () => {

            dispatch(resetDetail());
            if (submitBtnId == 'btnSaveNew') {
                setFormData({
                    S_Code: "",
                    S_Name: "",
                    S_Group: "",
                    S_Ord: "",
                })
            }
            else
                navigate(linksUrl.diamondParamater.shape.shapeMaster);
        },
    });

    const onSuccessChkDupCode = (data) => {
        let isDuplicate = 0
        if (isNewEntry && data && data.length > 0) {

            if (data[0].count > 0) {
                if (!toast.isActive("toast_chkshpid")) {
                    toast.error(`Duplicate Shape Code Found`, {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toast_chkcshpid"
                    })
                }
                isDuplicate = 1
            }
        }
        if (isDuplicate === 0) {
            addUpdateShape({
                data: {
                    ...formData,
                    UID: user.username,
                    pRecStatus: 2,
                }
            });


        }
    }
    const { mutate: funChkDuplicateSCode } = usePost({
        queryKey: "checkShapeCode",
        url: apiRoute.shape.checkShapeCode,
        onSuccessTasks: onSuccessChkDupCode
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnId(e.nativeEvent.submitter.id)
        if (!formData.S_Code.trim() || !formData.S_Name.trim()) {
            toast.warn("S_Code and S_Name are required.");
            return;
        }

        if (isNewEntry) {
            funChkDuplicateSCode({
                data: {
                    S_Code: formData.S_Code
                }
            })
        }
        if (!isNewEntry) {
            addUpdateShape({
                data: {
                    ...formData,
                    UID: user.username,
                    pRecStatus: 1,
                }
            });
        }

    };

    const { data: ordData = [] } = useFetchWithBody({
        url: apiRoute.shape.getNextSOrd,
        queryKey: "getNextSOrd",
    });


    useEffect(() => {
        if (isNewEntry) {
            setFormData((prev) => ({
                ...prev,
                S_Ord: ordData.nextSOrd,
            }));
        }
    }, [isNewEntry, ordData]);
    if (isLoading || isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <MainContainer
            pageName="Shape Entry"
            breadcrumbs={["Diamond Parameter", "Shape Master"]}
            prevPage={{ show: true, onClick: () => navigate(linksUrl.diamondParamater.shape.shapeMaster) }}
        >
            <Card className="p-6">
                <CardBody>
                    <form onSubmit={handleSubmit}>
                        <div className="grid gap-4">
                            <Input label="Shape Code" size="sm" maxLength={5} readOnly={isNewEntry ? false : true} name="S_Code" value={formData.S_Code} onChange={handleChange} isRequired />
                            <h2 className="text-red-300 " style={{fontSize:"0.7rem"}}>Shape code cannot be longer than 5 characters</h2>
                            <Input label="Shape Name" size="sm"  name="S_Name" value={formData.S_Name} onChange={handleChange} isRequired />
                            
                            <Input label="Shape Group" size="sm" name="S_Group" value={formData.S_Group} onChange={handleChange} />
                            <Input label="Shape Order" size="sm" name="S_Ord" type="number" value={formData.S_Ord} onChange={handleChange} />
                            <div className="flex gap-4 justify-center">
                                <Button type="submit" size="sm" id="submit" color="primary" isLoading={isPending}>
                                    {isNewEntry ? "Save " : "Update "}
                                </Button>
                                <Button
                                    id="btnSaveNew"
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    className="text-white"
                                    startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                                >
                                    Save & New
                                </Button>


                            </div>
                        </div>
                    </form>

                </CardBody>
            </Card>
        </MainContainer>
    );
};

export default CreateShapeMaster;

